export default {
  phone: 691,
  tablet: 1099,
  desktop: 1100,
}
